import { AnyAction } from "redux";
import { MODULE_NAME } from "../moduleName";
import { SvrSubmission } from "../services/domain/SvrSubmission";
import {
  PagedResponse,
  PatchWithMeta,
  QueryParams,
} from "@ofqual/portal-core/core/types";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const CREATING_SUBMISSION = `${MODULE_NAME}/CREATING_SUBMISSION`;
export const CREATING_SUBMISSION_VALIDATION_FAIL = `${MODULE_NAME}/CREATING_SUBMISSION_VALIDATION_FAIL`;
export const CREATED_SUBMISSION = `${MODULE_NAME}/CREATED_SUBMISSION`;

export const LOADED_SUBMISSIONS = `${MODULE_NAME}/LOADED_SUBMISSIONS`;
export const LOADING_SUBMISSIONS = `${MODULE_NAME}/LOADING_SUBMISSIONS`;

export const LOADED_SUBMISSION = `${MODULE_NAME}/LOADED_SUBMISSION`;
export const LOADING_SUBMISSION = `${MODULE_NAME}/LOADING_SUBMISSION`;

export const SAVED_SUBMISSION = `${MODULE_NAME}/SAVED_SUBMISSION`;
export const UPDATING_SUBMISSION = `${MODULE_NAME}/UPDATING_SUBMISSION`;
export const UPDATING_SUBMISSION_VALIDATION_FAIL = `${MODULE_NAME}/UPDATING_SUBMISSION_VALIDATION_FAIL`;

export const DEACTIVATING_SUBMISSION = `${MODULE_NAME}/DEACTIVATING_SUBMISSION`;

export const createSubmission = (submission: SvrSubmission) => ({
  type: CREATING_SUBMISSION,
  payload: submission,
});

export const loadedSubmissions = (payload: PagedResponse<SvrSubmission>) => ({
  type: LOADED_SUBMISSIONS,
  payload,
});
export const loadingSubmissions = (payload: QueryParams) => ({
  type: LOADING_SUBMISSIONS,
  payload,
});

export const loadingSubmission = (id: string) => ({
  type: LOADING_SUBMISSION,
  payload: id,
});

export const loadedSubmission = (submission: SvrSubmission) => ({
  type: LOADED_SUBMISSION,
  payload: submission,
});

export const updateSubmission = (
  id: string,
  patchWithMeta: PatchWithMeta<SvrSubmission>
  ) => ({
  type: UPDATING_SUBMISSION,
  payload: { id, patchWithMeta },
});

export const savedSubmission = (submission: SvrSubmission) => ({
  type: SAVED_SUBMISSION,
  payload: submission,
});

export const deactivateSubmission = (id: string) => ({
  type: DEACTIVATING_SUBMISSION,
  payload: { id },
});

